// =============================================================================
// Main JavaScript Entry Point
// Water Tech Shopify Theme
// =============================================================================

// Import Swiper (v9 - matches WordPress)
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css/bundle';

// Import Bootstrap JS components as needed
import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Tab from 'bootstrap/js/dist/tab';

// Make Swiper available globally for use in Liquid section scripts
window.Swiper = Swiper;
window.SwiperModules = { Navigation, Pagination, Autoplay };

// Make Bootstrap available globally BEFORE importing mega-menu
window.bootstrap = {
  Collapse,
  Modal,
  Dropdown,
  Offcanvas,
  Tab
};

// Import custom modules (after Bootstrap is set up)
import initHeroFullBanner from './modules/hero-full-banner';
import { initWhyWaterTechBanner } from './modules/why-water-tech-banner';
import initFullScreenImageWithText from './modules/full-screen-image-with-text';
import initMegaMenu from './global/mega-menu';
import './modules/product-info-and-image-gallery';
import './modules/product-features';
import './modules/product-slider';
import './product-nav';

// Initialize Bootstrap components
document.addEventListener('DOMContentLoaded', () => {
  console.log('Water Tech Shopify Theme Loaded');
  
  // Auto-initialize all Bootstrap collapse elements (accordions, etc.)
  document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(el => {
    new Collapse(el, { toggle: false });
  });
  
  // Initialize mega menu AFTER Bootstrap is ready
  initMegaMenu();
  
  // Initialize hero video module
  initHeroFullBanner();
  
  // Initialize why water tech banner animations
  initWhyWaterTechBanner();
  
  // Initialize full-screen-image-with-text scroll animations
  initFullScreenImageWithText();
});
